
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitmentRequest",
      function () {
        return require("private-next-pages/recruitmentRequest.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitmentRequest"])
      });
    }
  